<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M2.5 5.5H7.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.5 8.5H5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.1894 5.93936L16.3106 5.06068C15.7249 4.47489 14.7751 4.47489 14.1894 5.06068L7.43934 11.8107C7.15803 12.092 7 12.4735 7 12.8714V15.25H9.3787C9.7765 15.25 10.158 15.092 10.4394 14.8107L17.1894 8.06068C17.7751 7.47489 17.7751 6.52514 17.1894 5.93936Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'EditTextIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>